import React from "react";
import { Select } from "antd";
import Cookies from "js-cookie";
import intl from "react-intl-universal";

// 当前选中的语言
let currentLocale = intl.determineLocale({
  urlLocaleKey: 'lang',
  localStorageLocaleKey: 'lang'
});

// 多语言选择项
const selectLang = [
  {
    label: '简体中文',
    value: 'zh-CN'
  },
  {
    label: 'English',
    value: 'en-US'
  },
];

// 多语言选择框
function LangSelect(props) {
  return (
    <Select value={currentLocale || 'zh-CN'} onChange={(value) => {
      // const lang = e.target.value;
      window.location.search = `?lang=${value}`;
      window.localStorage.setItem('lang', value);
    }}>
      {selectLang.map(item => <Select.Option value={item.value}>{item.label}</Select.Option>)}
    </Select>
  )
}

export default LangSelect;
